/* eslint-disable */
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import { challengeResponseViewLink } from "helper/ChallengeHelper/ChallengeHelper";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

const ChallengeResponseHeader = ({
  breadcrumbText,
  ModuleName,
  reloadList,
  setAskAiSuggest,
}) => {
  const params = useParams();
  const { t } = useTranslation(); //for translation
  // const [listCanvanToggle, setListCanvanToggle] = useState("List");

  const listCanban = challengeResponseViewLink(params.id, t);
  // const [listCanban, setListCanban] = useState(['List', 'Canvan']);

  return (
    <div className="bg-white mt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        {/* ----------- bread crumb ------------- */}
        <div className="ps-1">
          <BreadCrumb breadCrumbText={breadcrumbText} />
        </div>

        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          {/* -------------- refresh ----------------- */}
          <Link
            onClick={reloadList}
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            title={t("Reload")}
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">{t("Reload")}</span>
          </Link>
          <div className="dropdown flex-fill flex-grow-sm-0">
            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fw-semibold small">{t("Action")}</span>
              <span className="material-symbols-outlined icon-lg ms-1">
                expand_more
              </span>
            </button>
            <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
              <li>
                <Link
                  to="#"
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  data-bs-toggle="modal"
                  data-bs-target="#addLabelModal"
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    label
                  </span>
                  <span className="d-block">{t("Add Label")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  data-bs-toggle="modal"
                  data-bs-target="#aisuggestreport_modal"
                  onClick={() => {
                    setAskAiSuggest(true);
                  }}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    delete
                  </span>
                  <span className="d-block">{t("Ask AI Suggest")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  data-bs-toggle="modal"
                  data-bs-target="#deletewarning"
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    delete
                  </span>
                  <span className="d-block">{t("Delete")}</span>
                </Link>
              </li>
            </ul>
          </div>
          <div className="dropdown flex-fill flex-grow-sm-0">
            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fw-semibold small">{t("List View")}</span>
              <span className="material-symbols-outlined icon-lg ms-1">
                expand_more
              </span>
            </button>
            <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
              {listCanban.map((item, index) => {
                return (
                  <li key={index}>
                    <Link
                      // onClick={() => setListCanvanToggle(item)}
                      to={item.path}
                      className="dropdown-item d-flex align-items-center gap-2 py-2"
                    >
                      {item.name}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
          {/* <Link
            to="#"
            className="btn btn-gray d-flex align-items-center gap-1"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasFilter"
            aria-controls="offcanvasFilter"
          >
            <span className="d-block material-symbols-outlined icon-md">
              tune
            </span>
            <span className="d-block">{t("Filter")}</span>
          </Link> */}
        </div>
      </div>
    </div>
  );
};

export default ChallengeResponseHeader;
